<template>
  <v-card>
    <v-card-title>Elementos dialógicos</v-card-title>
    <v-card-text>
      <canvas ref="chartCanvas"></canvas>
    </v-card-text>
  </v-card>
</template>

<script>
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, PieController } from 'chart.js';
import api from '@/api.js';

// 🔹 Registrar el PieController para que Chart.js lo reconozca
ChartJS.register(Title, Tooltip, Legend, ArcElement, PieController);

export default {
  name: 'ElementTypesCount',
  data() {
    return {
      elementTypesCountChart: null,
      chartData: {
        labels: [],
        datasets: [
          {
            backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'],
            data: [],
          }
        ]
      }
    };
  },
  methods: {
    async fetchData() {
      try {
        const projectId = this.$route.params.projectId;
        const response = await api.get(`/api/metrics/element/count-every-type/${projectId}`);
        const data = response.data;

        this.chartData.labels = Object.keys(data);
        this.chartData.datasets[0].data = Object.values(data);

        // Destruir el gráfico anterior si existe
        if (this.elementTypesCountChart) {
          this.elementTypesCountChart.destroy();
        }

        // Crear el gráfico con los nuevos datos
        this.createChart();
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    createChart() {
      if (!this.$refs.chartCanvas) {
        console.error('Canvas no encontrado');
        return;
      }

      const ctx = this.$refs.chartCanvas.getContext('2d');

      this.elementTypesCountChart = new ChartJS(ctx, {
        type: 'pie', // 🔹 Ya no dará error porque registramos `PieController`
        data: this.chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
        },
      });
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style scoped>
.v-card {
  max-width: 600px;
  margin: 20px auto;
}

.v-card-text {
  height: 400px;
}
</style>
